export const ANNOUNCEMENTS = 'announcements';
export const COMMON_ROOM = 'commonRoom';
